import cn from 'classnames'
import { memo, ReactNode } from 'react'

import styles from './Cart.module.css'

interface CartSubContentProps {
  type?: 'list' | 'normal' | 'founder'
  children?: ReactNode
  className?: string
}

const CartSubContent = memo(({ className, children, type = 'normal', ...props }: CartSubContentProps) => {
  if (type === 'list') {
    return (
      <li className={cn(styles.cartSubNormal, className)} {...props}>
        {children}
      </li>
    )
  } else if (type === 'founder') {
    return (
      <div className={cn(styles.cartSubfounder, styles.cartSubNormal, className)} {...props}>
        <li>
          <div className={cn(styles.cartitem)} {...props}>
            {children}
          </div>
        </li>
      </div>
    )
  } else {
    return (
      <div className={cn(styles.cartSubNormal, className)} {...props}>
        {children}
      </div>
    )
  }
})

export default CartSubContent
